/*eslint-disable */
import { ReglasConciliacionForm } from "feature-based/features/conciliaciones/organisms"
import {
  PropuestasConciliacionPage,
  ReglasConciliacion,
} from "feature-based/features/conciliaciones/pages"
import { Activos } from "features/Contabilidad"
import { DetalleImpuestos } from "features/Contabilidad/pages/DetalleImpuestos/DetalleImpuestos"
import DetalleModelo180 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo180/DetalleModelo180"
import DeclaracionModelo180 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo180/components/DeclaracionModelo180"
import DetalleModelo190 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo190/DetalleModelo190"
import DeclaracionModelo190 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo190/components/DeclaracionModelo190"
import DeclaracionModelo303 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo303/components/ResumenImpuestosDetail/DeclaracionModelo303/DeclaracionModelo303"
import ResumenImpuestosDetail from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo303/components/ResumenImpuestosDetail/ResumenImpuestosDetail"
import DetalleModelo347 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo347/DetalleModelo347"
import DeclaracionModelo347 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo347/components/DeclaracionModelo347"
import DeclaracionModelo349 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo349/components/Declaracion349"
import DeclaracionModelo390 from "features/Contabilidad/pages/DetalleImpuestos/components/Modelo390/components/DeclaracionModelo390"
import Informes from "features/Contabilidad/pages/Informes"
import LibroDiario from "features/Contabilidad/pages/LibroDiario/LibroDiario"
import LibroMayor from "features/Contabilidad/pages/LibroMayor/LibroMayor"
import Prestamos from "features/Contabilidad/pages/Prestamos/Prestamos"
import PrestamoDetail from "features/Contabilidad/pages/Prestamos/pages/PrestamoDetail/PrestamoDetail"
import Contactos from "features/Contactos"
import EditarContacto from "features/Contactos/pages/EditarContacto"
import CreacionAlbaran from "features/Crear/pages/CreacionAlbaran"
import CreacionFactura from "features/Crear/pages/CreacionFactura"
import CreacionFacturaProforma from "features/Crear/pages/CreacionFacturaProforma/CreacionFacturaProforma"
import CreacionFacturaRecurrente from "features/Crear/pages/CreacionFacturaRecurrente"
import CreacionPedido from "features/Crear/pages/CreacionPedido"
import CreacionPresupuesto from "features/Crear/pages/CreacionPresupuesto"
import Albaranes from "features/Documentos/pages/Albaranes"
import Facturas from "features/Documentos/pages/Facturas"
import FacturasFinanciables from "features/Documentos/pages/Facturas/FacturasFinanciables"
import FacturasProforma from "features/Documentos/pages/FacturasProforma"
import FacturasRecurrentes from "features/Documentos/pages/FacturasRecurrentes"
import FacturasRecurrentesDetail from "features/Documentos/pages/FacturasRecurrentes/pages/FacturasRecurrentesDetail"
import Pedidos from "features/Documentos/pages/Pedidos"
import Presupuestos from "features/Documentos/pages/Presupuestos"
import Tickets from "features/Documentos/pages/Tickets"
import CreationTicket from "features/Documentos/pages/Tickets/components/CreateTicket"
import ImportarActivos from "features/Importar/pages/ImportarActivos/ImportarActivos"
import ImportarContactos from "features/Importar/pages/ImportarContactos"
import ImportarProductos from "features/Importar/pages/ImportarProductos"
import Articulos from "features/Inventario/pages/Articulos"
import Catalogos from "features/Inventario/pages/Catalogos"
import Categorias from "features/Inventario/pages/Categorias"
import EditCatalogo from "features/Inventario/pages/EditCatalogo/EditCatalogo"
import NewCatalogo from "features/Inventario/pages/NewCatalogo/CatalogoForm"
import ViewCatalogo from "features/Inventario/pages/ViewCatalogo/ViewCatalogoContainer"
import { EmpresasGestionadas } from "features/MisEmpresas/EmpresasGestionadas"
import SeleccionDeEmpresa from "features/MisEmpresas/pages/SeleccionDeEmpresa"
import Notifications from "features/Notifications"
import ImportarFacturasORC from "features/OCR/pages/ImportarOCR"
import RevisionFacturasOCR from "features/OCR/pages/ImportarOCR/RevisionFacturas"
import Bancos from "features/Tesoreria/pages/Bancos/CuentasBancarias"
import TarjetasBancarias from "features/Tesoreria/pages/Bancos/TarjetasBancarias"
import BancosDetail from "features/Tesoreria/pages/Bancos/pages/BancosDetail/BancosDetail"
import Conciliaciones from "features/Tesoreria/pages/Bancos/pages/Conciliacion/Conciliaciones"
import TarjetaDetail from "features/Tesoreria/pages/Bancos/pages/TarjetaDetail/TarjetaDetail"
import Cartera from "features/Tesoreria/pages/Cartera/Cartera"
import CuentasContables from "features/Tesoreria/pages/CuentasContables"
import DevolucionIngresos from "features/Tesoreria/pages/DevolucionesIngresos"
import PagosCobros from "features/Tesoreria/pages/PagosCobros/PagosCobros"
import ReembolsoTickets from "features/Tesoreria/pages/ReembolsoTickets/ReembolsoTickets"
import Remesas from "features/Tesoreria/pages/Remesas"
import RemesaDetail from "features/Tesoreria/pages/Remesas/pages/RemesaDetail"
import ApprovalsManagement from "features/User/pages/ApprovalsManagement/ApprovalsManagement"
import CategoryManagement from "features/User/pages/CategoryManagement/CategoryManagement"
import CuadroCuentasContables from "features/User/pages/CuadroCuentasContables/CuadroCuentasContables"
import { Integraciones } from "features/User/pages/Integraciones/Integraciones"
import IntegrationPageUpdate from "features/User/pages/Integraciones/Pages/IntegracionUpdate/IntegrationUpdate"
import Enterprise from "features/User/pages/PerfilEmpresa"
import Profile from "features/User/pages/Profile"
import RoleManager from "features/User/pages/RoleManagement/RoleManagement"
import Taxes from "features/User/pages/Taxes/index"
import Cesiones from "features/Validaciones/pages/Cesiones"
import Documentos from "features/Validaciones/pages/Documentos"
import ValidacionesDetail from "features/Validaciones/pages/Documentos/DocumentosDetail/index"
import Financiacion from "features/Validaciones/pages/Financiacion"
import FinanciacionDetail from "features/Validaciones/pages/Financiacion/pages/FinanciacionDetail"
import { nanoid } from "nanoid"
import * as ROUTES from "./RoutePaths"

export const privateRoutes = [
  {
    path: ROUTES.FACTURAS,
    component: Facturas,
    key: nanoid(),
  },
  {
    path: ROUTES.FACTURAS_FINANCIABLES,
    component: FacturasFinanciables,
    key: nanoid(),
  },
  {
    path: ROUTES.FACTURAS_PROFORMA,
    component: FacturasProforma,
    key: nanoid(),
  },
  {
    path: ROUTES.PRESUPUESTOS,
    component: Presupuestos,
    key: nanoid(),
  },
  {
    path: ROUTES.PEDIDOS,
    component: Pedidos,
    key: nanoid(),
  },
  {
    path: ROUTES.ALBARANES,
    component: Albaranes,
    key: nanoid(),
  },
  {
    path: ROUTES.CREAR_TICKET,
    key: nanoid(),
    component: CreationTicket,
  },
  {
    path: ROUTES.EDITAR_TICKET,
    key: nanoid(),
    component: CreationTicket,
  },
  {
    path: ROUTES.TICKETS,
    key: nanoid(),
    component: Tickets,
  },
  {
    path: ROUTES.FACTURAS_RECURRENTES_DETAIL,
    component: FacturasRecurrentesDetail,
    key: nanoid(),
  },
  {
    path: ROUTES.FACTURAS_RECURRENTES,
    component: FacturasRecurrentes,
    key: nanoid(),
  },
  {
    path: ROUTES.CREAR_FACTURA,
    component: CreacionFactura,
    key: nanoid(),
  },
  {
    path: ROUTES.CREAR_FACTURA_PROFORMA,
    component: CreacionFacturaProforma,
    key: nanoid(),
  },
  {
    path: ROUTES.CREAR_FACTURA_RECURRENTE,
    component: CreacionFacturaRecurrente,
    key: nanoid(),
  },
  {
    path: ROUTES.EDITAR_FACTURA_RECURRENTE_ID,
    component: CreacionFacturaRecurrente,
    key: nanoid(),
  },
  {
    path: ROUTES.CREAR_PRESUPUESTO,
    component: CreacionPresupuesto,
    key: nanoid(),
  },
  {
    path: ROUTES.CREAR_PEDIDO,
    component: CreacionPedido,
    key: nanoid(),
  },
  {
    path: ROUTES.CREAR_ALBARAN,
    component: CreacionAlbaran,
    key: nanoid(),
  },
  {
    path: ROUTES.CONTACTOS,
    component: Contactos,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.EDITAR_CONTACTO,
    component: EditarContacto,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.ARTICULOS,
    component: Articulos,
    key: nanoid(),
  },
  {
    path: ROUTES.CATALOGOS,
    component: Catalogos,
    key: nanoid(),
  },
  {
    path: ROUTES.CATEGORIAS,
    component: Categorias,
    key: nanoid(),
  },
  {
    path: ROUTES.REVISION_FACTURA_OCR(),
    component: RevisionFacturasOCR,
    key: nanoid(),
  },
  {
    path: ROUTES.VALIDACIONES_DOCUMENTOS_DETAIL(),
    component: ValidacionesDetail,
    key: nanoid(),
  },
  {
    path: ROUTES.VALIDACIONES_FINANCIACION_DETAIL(),
    component: FinanciacionDetail,
    key: nanoid(),
  },
  {
    path: ROUTES.IMPORTAR_FACTURAS_OCR,
    component: ImportarFacturasORC,
    key: nanoid(),
  },
  {
    path: ROUTES.IMPORTAR_PRODUCTOS,
    component: ImportarProductos,
    key: nanoid(),
  },
  {
    path: ROUTES.IMPORTAR_CONTACTOS,
    component: ImportarContactos,
    key: nanoid(),
  },
  {
    path: ROUTES.IMPORTAR_ACTIVOS,
    component: ImportarActivos,
    key: nanoid(),
  },

  {
    path: ROUTES.CREAR_CATALOGO,
    component: NewCatalogo,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.VIEW_CATALOGO(),
    component: ViewCatalogo,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.EDIT_CATALOGO(),
    component: EditCatalogo,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.PROFILE,
    component: Profile,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.EMPRESA,
    component: Enterprise,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.MIS_EMPRESAS,
    component: SeleccionDeEmpresa,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.EMPRESAS_GESTIONADAS,
    component: EmpresasGestionadas,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.CUENTAS_CONTABLES,
    component: CuentasContables,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.ADMROLES,
    component: RoleManager,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.INTEGRATION_UPDATE,
    component: IntegrationPageUpdate,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.APPROVALS,
    component: ApprovalsManagement,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.COMPANY_CATEGORIES,
    component: CategoryManagement,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.TAXES,
    component: Taxes,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.INTEGRACIONES,
    component: Integraciones,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.CONTABILIDAD_CUENTAS(),
    component: CuadroCuentasContables,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.CONTABILIDAD_LIBRO,
    component: LibroDiario,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.LIBRO_MAYOR_DETAIL,
    component: LibroMayor,
    key: nanoid(),
  },
  {
    path: ROUTES.RESUMEN_IMPUESTOS,
    component: DetalleImpuestos,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.DECLARACION_MODELO_180,
    component: DeclaracionModelo180,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.DECLARACION_MODELO_190,
    component: DeclaracionModelo190,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.DECLARACION_MODELO_303,
    component: DeclaracionModelo303,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.DECLARACION_MODELO_180,
    component: DeclaracionModelo180,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.DECLARACION_MODELO_347,
    component: DeclaracionModelo347,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.DECLARACION_MODELO_349,
    component: DeclaracionModelo349,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.DECLARACION_MODELO_390,
    component: DeclaracionModelo390,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.RESUMEN_IMPUESTOS_DETAIL_180,
    component: DetalleModelo180,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.RESUMEN_IMPUESTOS_DETAIL_190,
    component: DetalleModelo190,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.RESUMEN_IMPUESTOS_DETAIL_347,
    component: DetalleModelo347,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.RESUMEN_IMPUESTOS_DETAIL,
    component: ResumenImpuestosDetail,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.ACTIVOS,
    component: Activos.ActivosDefault,
    key: ROUTES.ACTIVOS,
    exact: true,
  },
  {
    path: ROUTES.ACTIVO_ID,
    component: Activos.ActivoId,
    key: ROUTES.ACTIVO_ID,
    exact: true,
  },
  {
    path: ROUTES.CARTERA,
    component: Cartera,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.PAGOS_COBROS,
    component: PagosCobros,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.REMESAS,
    component: Remesas,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.REMESAS_DETAIL,
    component: RemesaDetail,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.REGLAS_CONCILIACION,
    component: ReglasConciliacion,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.REGLAS_CONCILIACION_DETAIL,
    component: ReglasConciliacion,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.REGLAS_CONCILIACION_REGLA,
    component: ReglasConciliacionForm,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.REGLAS_CONCILIACION_REGLA_DETAIL,
    component: ReglasConciliacionForm,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.PROPUESTAS_CONCILIACION_DETAIL,
    component: PropuestasConciliacionPage,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.CONTABILIDAD_BALANCE,
    component: Informes,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS,
    component: Informes,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.CONTABILIDAD_SUMAS_SALDOS,
    component: Informes,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.PRESTAMOS,
    component: Prestamos,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.PRESTAMOS_DETAIL,
    component: PrestamoDetail,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.NOTIFICATIONS,
    component: Notifications,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.BANCOS,
    component: Bancos,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.TARJETAS,
    component: TarjetasBancarias,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.CONCILIACION(),
    component: Conciliaciones,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.BANCOS_DETAIL,
    component: BancosDetail,
    key: nanoid(),
    exact: false,
  },
  {
    path: ROUTES.TARJETA_DETAIL,
    component: TarjetaDetail,
    key: nanoid(),
    exact: false,
  },
  {
    path: ROUTES.DEVOLUCIONES_INGRESOS,
    component: DevolucionIngresos,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.REEMBOLSO_TICKETS,
    component: ReembolsoTickets,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.VALIDACIONES_CESIONES,
    component: Cesiones,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.VALIDACIONES_FINANCIACION,
    component: Financiacion,
    key: nanoid(),
    exact: true,
  },
  {
    path: ROUTES.VALIDACIONES_DOCUMENTOS,
    component: Documentos,
    key: nanoid(),
    exact: true,
  },
]
